import React, {useEffect, useRef} from 'react'
import { useTranslation } from 'react-i18next';
import { marginTop80 } from '../style'

const Banner = () => {
  const { t } = useTranslation();
  const trigger = useRef<HTMLInputElement>(null)

  useEffect(() => {
    
  })

  const executeScroll = () => {
    let triggerPos = 280
    if(trigger.current!==null)
      triggerPos = trigger.current.offsetTop
    console.log('triggerPos',triggerPos);
    
    window.scrollTo({ behavior: 'smooth', top: triggerPos - 170})
  }
    return(
        <>
            <section className="knsl-banner">
                <div className="knsl-cover-frame">
                    <img src="assets/img/banners/1.jpg" alt="banner" className="knsl-parallax"/>
                </div>
                <div className="knsl-overlay"></div>

                <div className="knsl-banner-content">
                    <div className="container">
                        <div className="knsl-main-title">
                            <div className="knsl-white">
                            <ul className="knsl-stars">
                                <li className="knsl-empty"><i className="fas fa-star"></i></li>
                                <li className="knsl-empty"><i className="fas fa-star"></i></li>
                                <li><i className="fas fa-star"></i></li>
                                <li className="knsl-empty"><i className="fas fa-star"></i></li>
                                <li className="knsl-empty"><i className="fas fa-star"></i></li>
                            </ul>
                            {/* <!-- main-title --> */}
                            <h1 className="knsl-center knsl-mb-10">{t('main.welcome')}</h1>
                            <div className="knsl-mb-30 knsl-center">{t('main.welcomeDescription')}</div>
                            </div>
                        </div>
                        <div className="knsl-banner-buttons knsl-mb-30 knsl-center">
                            <a data-fancybox href="https://www.youtube.com/watch?v=wsq-r8lMMsk" className="knsl-btn knsl-transparent-border">
                            <img src="assets/img/icons/play.svg" alt="icon" className="knsl-zoom" />{t('main.watchVideo')}
                            </a>
                            <a href="/#" id="book-popup-2" className="knsl-btn knsl-transparent-border knsl-btn-accent-2">
                            <img src="assets/img/icons/bookmark.svg" alt="icon"/>{t('main.bookNow')}
                            </a>
                        </div>
                        <div className="knsl-scroll-hint-frame">
                            <div className="knsl-white knsl-mb-20">{t('main.scrollDown')}</div>
                            <button onClick={executeScroll} className="knsl-scroll-hint knsk-s-s"> </button>
                        </div>
                    </div>
                </div>
            </section>
            <section ref={trigger}>

                <div className="container">

                    {/* <!-- features card --> */}
                    <div className="knsl-features-card" style={marginTop80}>

                    <div className="row">
                        <div className="col-6 col-lg-3">

                        {/* <!-- icon box --> */}
                        <div className="knsl-icon-box">
                            <img src="assets/img/features/6.svg" alt="Free &aspm; unlimited Wifi" className="knsl-mb-10"/>
                            <h5>{t('main.freeWifi')}</h5>
                        </div>
                        {/* <!-- icon box end --> */}

                        </div>
                        <div className="col-6 col-lg-3">

                        {/* <!-- icon box --> */}
                        <div className="knsl-icon-box">
                            <img src="assets/img/features/2.svg" alt="All inclusive" className="knsl-mb-10"/>
                            <h5>{t('main.allInclusive')}</h5>
                        </div>
                        {/* <!-- icon box end --> */}

                        </div>
                        <div className="col-6 col-lg-3">

                        {/* <!-- icon box --> */}
                        <div className="knsl-icon-box">
                            <img src="assets/img/features/3.svg" alt="Air-conditioned" className="knsl-mb-10"/>
                            <h5>{t('main.airConditioned')}</h5>
                        </div>
                        {/* <!-- icon box end --> */}

                        </div>
                        <div className="col-6 col-lg-3">

                        {/* <!-- icon box --> */}
                        <div className="knsl-icon-box">
                            <img src="assets/img/features/4.svg" alt="Under protection" className="knsl-mb-10"/>
                            <h5>{t('main.underProtection')}</h5>
                        </div>
                        {/* <!-- icon box end --> */}

                        </div>
                    </div>

                    </div>
                    {/* <!-- features card end --> */}

                </div>
            </section>
        </>
    )
}

export default Banner